import { useCallback, useState } from 'react';

import { replaceAllStringWithSymbol } from '@developer/portal/utils';

type UseAPIAccessParams = {
  originalClientId: string;
  originalSecret: string;
  shouldNotBeDefaultHidden: boolean;
};

export default function useHiddenAPIAccess({
  originalClientId,
  originalSecret,
  shouldNotBeDefaultHidden = true,
}: UseAPIAccessParams) {
  const [secret, setSecret] = useState(
    shouldNotBeDefaultHidden
      ? originalSecret
      : replaceAllStringWithSymbol(originalSecret, '.')
  );
  const [clientID, setClientID] = useState(
    shouldNotBeDefaultHidden
      ? originalClientId
      : replaceAllStringWithSymbol(originalClientId, '.')
  );

  const [isClientIDHidden, setIsClientIDHidden] = useState(true);
  const [isSecretHidden, setIsSecretHidden] = useState(true);

  const btnShowClientIDHandler = useCallback(() => {
    setIsClientIDHidden(!isClientIDHidden);
    setClientID(
      !isClientIDHidden
        ? replaceAllStringWithSymbol(originalClientId, '.')
        : originalClientId
    );
  }, [setIsClientIDHidden, isClientIDHidden, originalClientId]);

  const btnShowSecretHandler = useCallback(() => {
    setIsSecretHidden(!isSecretHidden);
    setSecret(
      !isSecretHidden
        ? replaceAllStringWithSymbol(originalSecret, '.')
        : originalSecret
    );
  }, [setIsSecretHidden, isSecretHidden, originalSecret]);

  const btnCopySecretHandler = useCallback(() => {
    navigator.clipboard.writeText(originalSecret);
  }, [originalSecret]);

  const btnCopyClientIDHandler = useCallback(() => {
    navigator.clipboard.writeText(originalClientId);
  }, [originalClientId]);

  return {
    secret,
    clientID,
    isClientIDHidden,
    isSecretHidden,
    btnShowSecretHandler,
    btnCopySecretHandler,
    btnShowClientIDHandler,
    btnCopyClientIDHandler,
  };
}
